<div class="fab-container">
  <button mat-fab [matMenuTriggerFor]="langMenu" class="fab">
    <span class="current-lang">{{configService.preferedLanguage() | uppercase }}</span>
  </button>

  <mat-menu #langMenu="matMenu" class="menu">
    @for (lang of LANGUAGES; track lang) {
      <button mat-menu-item (click)="setLanguage(lang)">
        <span>{{ lang.name }}</span>
      </button>
    }
  </mat-menu>
</div>